import AxiosJob from '@/services/api/job/axios_job'

export default {
  createComment: (data) => {
    return AxiosJob.post('comment', data)
  },

  getJobComments: (jobId, params) => {
    return AxiosJob.get(`job/${jobId}/comments`, { params })
  },

  getComment: (commentId) => {
    return AxiosJob.get(`comment/${commentId}`)
  }
}
